module.exports = __webpack_public_path__ + "static/media/code_image.65d0cbdc.png";